import { Breakpoints, breakpointSizes, IS_CLIENT } from '../constants';
import { MediaTouchpoint } from './types';
/**
 * Checks if given width matches current window media max-width.
 * @param {number} width - screen width in pixels
 * @return {boolean}
 */
export const isMatchesMaxMedia = (width) => IS_CLIENT && window.matchMedia(`(max-width: ${width}px)`).matches;
/**
 * Returns the current window media touchpoint.
 * Is simillar to getTouchpoint() but returns media touchpoints exclusively
 * @return {MediaTouchpoint}
 */
export const getMediaTouchpoint = () => {
    switch (true) {
        case isMatchesMaxMedia(breakpointSizes[Breakpoints.SMALL]):
            return MediaTouchpoint.MOBILE;
        case isMatchesMaxMedia(breakpointSizes[Breakpoints.MEDIUM]):
            return MediaTouchpoint.TABLET;
        default:
            return MediaTouchpoint.DESKTOP;
    }
};
//# sourceMappingURL=getMediaTouchpoint.js.map